<template>
  <section class="main">
    <h1 class="intro">{{ $t('HOW_TO_SIDELOAD') }}</h1>

    <div class="notice-container">
      <html-with-links tag="div" class="notice"
        :html="$t('SIDELOADING_NOTICE', { href: '/my/installation-history' })" />
    </div>

    <div class="row">
      <div class="content">

        <!-- Official Sideloading Section -->
        <section id="official" class="faq-section">
          <div class="heading-container">
            <div class="heading-inline">
              <html-with-links tag="h2" class="section-heading"
                :html="$t('OFFICIAL_SIDELOADING_HEADING')"></html-with-links>
              <span v-if="isOfficialMethod" class="used-now-badge">{{ $t('USED_NOW') }}</span>
            </div>
          </div>
          <div class="section-content">
            <h3 class="comparison-heading">{{ $t('THIS_IS_THE_RECOMMENDED_WAY_TO_USE') }}</h3>
            <table class="table">
              <tr>
                <th>{{ $t('PRICE') }}</th>
                <td>{{ $t('OFFICIAL_SIDELOADING_PRICE') }}</td>
              </tr>
              <tr>
                <th>{{ $t('BENEFITS') }}</th>
                <td>{{ $t('OFFICIAL_SIDELOADING_BENEFITS') }}</td>
              </tr>
              <tr>
                <th>{{ $t('DISADVANTAGES') }}</th>
                <td>{{ $t('OFFICIAL_SIDELOADING_DISADVANTAGES') }}</td>
              </tr>
            </table>

            <h3 class="comparison-heading">{{ $t('HOW_TO_CONFIGURE_IT') }}:</h3>

            <ol class="steps">
              <li class="steps__step" :class="{
                'accent-animation': $route.query.accent === 'step-1'
              }">
                <img class="steps__icon" src="@/assets/devapp.png" />
                <div @click="purchase"
                  v-html="$t('PLUS_STEP_1', { href: '#' }) + ' ' + '(<a href=\'https://www.youtube.com/watch?v=QFs7uVk7s4Y\' target=\'_blank\'>' + $t('VIDEO_TUTORIAL') + '</a>)'">
                </div>
              </li>
              <li class="steps__step">
                <img class="steps__icon"
                  :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-mobile-${theme}.svg`)" />
                <html-with-links
                  :html="$t('PLUS_STEP_2', { href: '/my/apple' }) + ' ' + '(<a href=\'https://www.youtube.com/watch?v=-ShhaoaLWyE\' target=\'_blank\'>' + $t('VIDEO_TUTORIAL') + '</a>)'" />
              </li>
              <!--<li class="steps__step">
                <img class="steps__icon" src="@/assets/cashback.png" />
                <html-with-links :html="$t('PLUS_STEP_3', { href: '/my/auto-reimbursement' })" />
              </li>-->
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('INSTALL_APPS_WITH_BUTTONS')" />
              </li>
            </ol>
          </div>
        </section>

        <!-- Premium Sideloading Section -->
        <!--<section id="premium" class="faq-section">
          <div class="heading-container">
            <div class="heading-inline">
              <html-with-links tag="h2" class="section-heading"
                :html="$t('PREMIUM_SIDELOADING_HEADING')"></html-with-links>
              <span v-if="isPremiumMethod" class="used-now-badge">{{ $t('USED_NOW') }}</span>
              <span v-if="premiumUnavailable" class="unavailable-now-badge">{{ $t('UNAVAILABLE_NOW') }}</span>
            </div>
          </div>
          <div class="section-content">
            <h3 class="comparison-heading">{{ $t('THIS_IS_THE_RECOMMENDED_WAY_TO_USE_NO_ACCOUNT') }}</h3>
            <table class="table">
              <tr>
                <th>{{ $t('PRICE') }}</th>
                <td>{{ $t('PREMIUM_SIDELOADING_PRICE') }}</td>
              </tr>
              <tr>
                <th>{{ $t('BENEFITS') }}</th>
                <td>{{ $t('PREMIUM_SIDELOADING_BENEFITS') }}</td>
              </tr>
              <tr>
                <th>{{ $t('DISADVANTAGES') }}</th>
                <td>{{ $t('PREMIUM_SIDELOADING_DISADVANTAGES') }}</td>
              </tr>
            </table>

            <h3 class="comparison-heading">{{ $t('HOW_TO_CONFIGURE_IT') }}:</h3>

            <ol class="steps">
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('PREMIUM_STEP_1')" />
              </li>
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('INSTALL_APPS_WITH_BUTTONS')" />
              </li>
            </ol>

            <p class="g-text" style="margin: 20px 0 15px;" v-html="$t('PREMIUM_DESCRIPTION')"></p>

            <sideloading-options :options="premiumOptions" v-if="!premiumUnavailable" targetUrl="/my/premium" />
          </div>
        </section>-->

        <!-- P2P Sideloading Section -->
        <!--<section id="p2p" class="faq-section">
          <div class="heading-container">
            <div class="heading-inline">
              <html-with-links tag="h2" class="section-heading" :html="$t('P2P_SIDELOADING_HEADING')"></html-with-links>
              <span v-if="isP2PMethod" class="used-now-badge">{{ $t('USED_NOW') }}</span>
            </div>
          </div>
          <div class="section-content">

            <table class="table">
              <tr>
                <th>{{ $t('PRICE') }}</th>
                <td>
                  <html-with-links :html="$t('P2P_SIDELOADING_PRICE', { href: '/my/p2p-certificates' })" />
                </td>
              </tr>
              <tr>
                <th>{{ $t('BENEFITS') }}</th>
                <td>{{ $t('P2P_SIDELOADING_BENEFITS') }}</td>
              </tr>
              <tr>
                <th>{{ $t('DISADVANTAGES') }}</th>
                <td>{{ $t('P2P_SIDELOADING_DISADVANTAGES') }}</td>
              </tr>
            </table>

            <h3 class="comparison-heading">{{ $t('HOW_TO_CONFIGURE_IT') }}:</h3>

            <ol class="steps">
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('P2P_STEP_1', { href: '/my/p2p-certificates' })" />
              </li>
            </ol>

            <p class="g-text" style="margin: 20px 0 15px;" v-html="$t('PLUS_DESCRIPTION')"></p>

            <sideloading-options :options="officialOptions" />
          </div>
        </section>-->

        <!-- 3rd Party Sideloading Section -->
        <section id="3rdparty" class="faq-section">
          <div class="heading-container">
            <div class="heading-inline">
              <html-with-links tag="h2" class="section-heading"
                :html="$t('3RD_PARTY_SIDELOADING_HEADING')"></html-with-links>
              <span v-if="isCertificateMethod" class="used-now-badge">{{ $t('USED_NOW') }}</span>
            </div>
          </div>
          <div class="section-content">


            <table class="table">
              <tr>
                <th>{{ $t('PRICE') }}</th>
                <td>
                  <html-with-links :html="$t('3RD_PARTY_SIDELOADING_PRICE')" />
                </td>
              </tr>
              <tr>
                <th>{{ $t('BENEFITS') }}</th>
                <td>{{ $t('3RD_PARTY_SIDELOADING_BENEFITS') }}</td>
              </tr>
              <tr>
                <th>{{ $t('DISADVANTAGES') }}</th>
                <td>{{ $t('3RD_PARTY_SIDELOADING_DISADVANTAGES') }}</td>
              </tr>
            </table>

            <h3 class="comparison-heading">{{ $t('HOW_TO_CONFIGURE_IT') }}:</h3>

            <ol class="steps" style="margin-bottom: 15px;">
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('3RD_PARTY_SIDELOADING_DESC')" />
              </li>
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('INSTALL_APPS_WITH_BUTTONS')" />
              </li>
            </ol>

            <sideloading-options v-if="thirdPartyOptions.length" :options="thirdPartyOptions" />
            <br />
            <p class="g-text"
              v-html="$t('3RD_PARTY_SIDELOADING_PROGRAM', { href: 'https://rtfm.dbservices.to/#/integrations/easy-certificate-linking' })">
            </p>

            <!--<p style="margin: 10px 0; font-weight: 700;">Already purchased?</p>

            <div v-if="devCredentialsProviders.length" class="inline-buttons">
              <template v-for="provider in devCredentialsProviders">
                <btn
                  type="primary"
                  @click.native.prevent="importDevCredetials(provider.href)"
                  :key="provider.name"
                >{{ $t('IMPORT_FROM', { from: provider.name }) }}
                </btn>&nbsp;
              </template>
</div>

<html-with-links style="margin-top: 10px;" tag="div"
  :html="$t('INTEGRATE_EASY_LINKING_NOTICE',{link:'https://rtfm.dbservices.to/#/integrations/easy-certificate-linking'})"></html-with-links>-->
          </div>
        </section>

        <!-- Free Apple Account Sideloading Section -->
        <section id="free_apple" class="faq-section">
          <div class="heading-container">
            <div class="heading-inline">
              <html-with-links tag="h2" class="section-heading"
                :html="$t('FREE_APPLE_ACCOUNT_HEADING')"></html-with-links>
              <span v-if="isFreeAppleMethod" class="used-now-badge">{{ $t('USED_NOW') }}</span>
            </div>
          </div>
          <div class="section-content">
            <h3 class="comparison-heading">{{ $t('BEST_EFFORT_NOTICE') }}</h3>
            <table class="table">
              <tr>
                <th>{{ $t('PRICE') }}</th>
                <td>{{ $t('FREE_APPLE_ACCOUNT_PRICE') }}</td>
              </tr>
              <tr>
                <th>{{ $t('BENEFITS') }}</th>
                <td>{{ $t('FREE_APPLE_ACCOUNT_BENEFITS') }}</td>
              </tr>
              <tr>
                <th>{{ $t('DISADVANTAGES') }}</th>
                <td>{{ $t('FREE_APPLE_ACCOUNT_DISADVANTAGES') }}</td>
              </tr>
            </table>

            <h3 class="comparison-heading">{{ $t('HOW_TO_CONFIGURE_IT') }}:</h3>

            <ol class="steps">
              <li class="steps__step">
                <img class="steps__icon" src="https://a.appdb.to/appdb_jitpair_releases/icon.png" />
                <html-with-links
                  :html="$t('ENABLE_JIT_STEP_1', { href_jitpair: '/appdb-jitpair', href_configure: '/my/configure' })" />
              </li>
              <li class="steps__step">
                <img class="steps__icon" src="@/assets/shortcuts-app.png" />
                <html-with-links
                  :html="$t('CONFIGURE_FREE_ACCOUNT_STEP_2', { href: 'https://www.icloud.com/shortcuts/e1f8b3caad4b4fa7b4d8dc56262a4ad0' })" />
              </li>
              <li class="steps__step">
                <img class="steps__icon"
                  :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-mobile-${theme}.svg`)" />
                <html-with-links :html="$t('PLUS_STEP_2', { href: '/my/free-apple' })" />
              </li>
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('INSTALL_APPS_WITH_BUTTONS')" />
              </li>
            </ol>
          </div>
        </section>

        <!-- Enterprise Sideloading Section -->
        <section id="enterprise" class="faq-section">
          <div class="heading-container">
            <div class="heading-inline">
              <html-with-links tag="h2" class="section-heading"
                :html="$t('FREE_ENTERPRISE_SIDELOADING_HEADING')"></html-with-links>
              <span v-if="isEnterpriseMethod" class="used-now-badge">{{ $t('USED_NOW') }}</span>
              <span v-if="enterpriseUnavailable" class="unavailable-now-badge">{{ $t('UNAVAILABLE_NOW') }}</span>
            </div>
          </div>
          <div class="section-content">
            <table class="table">
              <tr>
                <th>{{ $t('PRICE') }}</th>
                <td>
                  <html-with-links :html="$t('FREE_ENTERPRISE_SIDELOADING_PRICE')" />
                </td>
              </tr>
              <tr>
                <th>{{ $t('BENEFITS') }}</th>
                <td>{{ $t('FREE_ENTERPRISE_SIDELOADING_BENEFITS') }}</td>
              </tr>
              <tr>
                <th>{{ $t('DISADVANTAGES') }}</th>
                <td>{{ $t('FREE_ENTERPRISE_SIDELOADING_DISADVANTAGES') }}</td>
              </tr>
            </table>

            <h3 class="comparison-heading">{{ $t('HOW_TO_CONFIGURE_IT') }}:</h3>
            <ol class="steps" style="margin-bottom: 15px;">
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('FREE_ENTERPRISE_SIDELOADING_DESC')" />
              </li>
              <li class="steps__step">
                &nbsp;&nbsp;&nbsp;<html-with-links :html="$t('INSTALL_APPS_WITH_BUTTONS')" />
              </li>
            </ol>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';
import SideloadingOptions from '@/components/SideloadingOptions.vue';

export default {
  components: {
    HtmlWithLinks,
    SideloadingOptions,
  },
  data() {
    return {
      officialOptions: [],
      thirdPartyOptions: [],
      plusOptions: [],
      premiumOptions: [],
      devCredentialsProviders: [],
      enterpriseCerts: null,
    };
  },
  computed: {
    title() {
      return this.$t('HOW_TO_SIDELOAD_AND_USE_PLUS');
    },
    ...mapState(['theme', 'currentDevice', 'config']),
    installationMethod() {
      // Get installation method from either currentDevice or directly from config
      return (this.currentDevice && this.currentDevice.app_installation_method)
        || (this.config && this.config.app_installation_method) || '';
    },
    isOfficialMethod() {
      const method = this.installationMethod;
      return ['dev_account'].includes(method);
    },
    isP2PMethod() {
      const method = this.installationMethod;
      return ['shared_dev_account'].includes(method);
    },
    isPremiumMethod() {
      const method = this.installationMethod;
      return ['premium_shared_dev_account'].includes(method);
    },
    isCertificateMethod() {
      const method = this.installationMethod;
      return method === 'certificate';
    },
    isEnterpriseMethod() {
      const method = this.installationMethod;
      return method === 'enterprise';
    },
    isFreeAppleMethod() {
      const method = this.installationMethod;
      return method === 'free_dev_account';
    },
    enterpriseUnavailable() {
      return this.enterpriseCerts !== null && Array.isArray(this.enterpriseCerts) && this.enterpriseCerts.length === 0;
    },
    premiumUnavailable() {
      return this.$store.state.stats.premium_slots_available === 0;
    },
  },
  methods: {
    purchase(e) {
      if (!e.target?.matches('a[href="#"]')) {
        return;
      }
      e.preventDefault();

      this.$alert(`<div class="g-text">${this.$t('PLUS_DOWNLOAD_APP', { href: 'https://apps.apple.com/us/app/apple-developer/id640199958' })}</div>`);
    },
    importDevCredetials(href) {
      this.$confirm(this.$t('IMPORT_DEV_CREDENTIALS_PROVIDER_CONFIRMATION'))
        .then(() => {
          window.location.href = href;
        });
    },
    scrollToHash() {
      if (window.location.hash) {
        const id = window.location.hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          setTimeout(() => {
            const yOffset = -20;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }, 300);
        }
      }
    },
  },
  created() {
    this.$api.getSideloadingOptions('official').then((response) => {
      this.officialOptions = response;
    });

    this.$api.getSideloadingOptions('3rdparty').then((response) => {
      this.thirdPartyOptions = response;
    });

    /* this.$api.getDevCredentialsProviders()
      .then((response) => {
        this.devCredentialsProviders = response;
      }); */

    this.$api.getSideloadingOptions('plus').then((response) => {
      this.plusOptions = response;
    });

    this.$api.getSideloadingOptions('premium').then((response) => {
      this.premiumOptions = response;
    });

    this.$api.getEnterpriseCertificates().then((response) => {
      this.enterpriseCerts = response;
    });

    this.$store.dispatch('getStats');
  },
  mounted() {
    this.scrollToHash();
  },
  updated() {
    this.scrollToHash();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
}

.notice-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.notice {
  background-color: var(--secondary-bg);
  border: 1px solid var(--tertiary-accent);
  border-left: 4px solid var(--primary);
  border-radius: 5px;
  padding: 15px 20px;
  text-align: center;
  max-width: 800px;
  line-height: 1.5;

  a {
    color: var(--primary);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @include tablet {
    padding: 12px 15px;
    font-size: 14px;
    margin: 0 10px;
  }
}

.row {
  display: flex;
  align-items: flex-start;

  @include notebook {
    flex-wrap: wrap;
  }
}

.content {
  flex-grow: 1;

  @include notebook {
    order: 1;
  }
}

.col {
  &_1 {
    flex-grow: 1;
  }

  &_2 {
    flex: 0 0 192px;
    margin-left: 15px;

    @include notebook {
      margin-left: 0;
      margin-top: 0;
    }
  }

  @include notebook {
    flex: 0 0 100%;
  }
}

.content::v-deep .g-text {
  margin-bottom: 10px;
  line-height: 1.2;
}

.table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: var(--secondary-bg);

  th {
    background-color: var(--secondary-bg);
    color: var(--text-secondary);
    font-weight: 600;
    text-align: left;
    padding: 12px 15px;
    border-bottom: 1px solid var(--tertiary-accent);
    width: 25%;
  }

  td {
    padding: 12px 15px;
    vertical-align: middle;
    white-space: pre-line;
    line-height: 1.4;
    color: var(--text-primary);
    border-bottom: 1px solid var(--tertiary-accent);
  }

  tr:last-child {

    th,
    td {
      border-bottom: none;
    }
  }

  @include tablet {
    th {
      width: 35%;
      padding: 10px;
    }

    td {
      padding: 10px;
    }
  }
}

.badge {
  display: inline-block;
  background-color: var(--primary);
  color: #fff;
  padding: 3px 4px 2px 4px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
}

.comparison-heading {
  font-size: 16px;
  margin: 15px 0 10px;
  color: var(--text-tertiary);
  font-weight: 600;
}

.text {
  text-align: justify;
}

.steps {
  counter-reset: steps;

  &__step {
    display: flex;
    align-items: center;
    font-size: 16px;

    &:not(:last-child) {
      margin-bottom: 15px;

      @include tablet {
        margin-bottom: 10px;
      }
    }

    &::before {
      counter-increment: steps;
      content: counter(steps) ".";
      font-size: 25px;

      @include tablet {
        font-size: 18px;
      }
    }
  }

  &__icon {
    margin: 0 10px;
    max-width: 50px;
    width: 100%;

    @include tablet {
      max-width: 40px;
    }
  }
}

.plus-icon {
  background-color: var(--primary);
  color: #fff;
  font-size: 21px;
  padding: 10px 0;
  text-align: center;
  border-radius: 4px;
  font-weight: 600;

  @include tablet {
    font-size: 12px;
    padding: 6px 0;
  }
}

.inline-buttons {
  line-height: 33px;
  margin-top: -5px;

  .button {
    display: inline;
  }
}

/* New styles for FAQ sections */
.faq-section {
  border-radius: 5px;
  border: 1px solid var(--tertiary-accent);
  margin-bottom: 15px;
  overflow: hidden;
}

.heading-container {
  background-color: var(--secondary-bg);
  border-bottom: 1px solid var(--tertiary-accent);
  padding: 12px 10px;
}

.heading-inline {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
}

.section-heading {
  font-size: 15px;
  padding: 0;
  margin: 0;
  font-weight: 600;
  position: relative;
  display: inline;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;

  @include notebook {
    font-size: 14px;
  }
}

.used-now-badge {
  display: inline-block;
  background-color: var(--primary);
  color: white;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  margin-left: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  flex-shrink: 0;
}

.unavailable-now-badge {
  display: inline-block;
  background-color: red;
  color: white;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  margin-left: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  flex-shrink: 0;
}

.section-content {
  padding: 15px;
}

.accent-animation {
  animation: highlight-background 2s ease-in-out;
}

@keyframes highlight-background {

  0%,
  100% {
    background-color: transparent;
  }

  50% {
    background-color: var(--bg-highlight);
  }
}
</style>
